import { Skeleton } from '@radix-ui/themes';
import { ErrorBoundary } from 'components/common/error-boundary';
import { SessionHitsSummariesTable } from 'components/sections/analytics/session-hits-summaries/table';
import useAnalyticsStore from 'components/sections/analytics/store/use-analytics-store';
import { SectionName } from 'enums/route.enums';
import { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';

interface IProps {
  refetchSummaries: () => void;
}

export const HitterProfileReports = (props: IProps) => {
  const loading = useAnalyticsStore((s) => s.loadingSessions || s.loadingHits);

  const { hitterID } = useParams<{
    hitterID: string;
  }>();

  // after reassignment, fetch sessions again
  const [refetchKey, setRefetchKey] = useState(Date.now());

  useEffect(() => {
    if (!hitterID) {
      return;
    }

    useAnalyticsStore.getState().fetchSessions({
      hitterID: hitterID,
      limit: 100,
    });
  }, [hitterID, refetchKey]);

  return (
    <ErrorBoundary identifier="HitterProfileReports">
      <Skeleton loading={loading}>
        <SessionHitsSummariesTable
          within={SectionName.HitterLibrary}
          refetchSessions={async () => {
            setRefetchKey(Date.now());
            await props.refetchSummaries();
          }}
        />
      </Skeleton>
    </ErrorBoundary>
  );
};
